import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=2b542dd9"
import script from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=2b542dd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports